import { Box, IconButton, styled } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { primary } from 'helpers/colors';

export const CustomList = styled(List)(({ theme }) => ({
  paddingTop: 18,
  backgroundColor: theme.palette.primary.main,
  margin: 6
}));

export const CustomListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== '$active'
})<{ $active?: boolean }>(({ $active }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  position: 'relative',
  color: '#f2f2f2',
  padding: '12px 12px',
  cursor: 'pointer',
  minHeight: 50,
  '&::before': {
    content: '""',
    width: '100%',
    height: '100%',
    maxWidth: $active ? '100%' : 0,
    position: 'absolute',
    top: 0,
    left: 0,
    transition: 'all .3s ease-in-out',
    backgroundColor: $active ? primary.dark : primary.hover,
    borderRadius: 6,
    zIndex: 3
  },
  '&::after': $active
    ? {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        height: '60%',
        width: 3,
        backgroundColor: '#cad225',
        borderRadius: '0 3px 3px 0',
        zIndex: 4
      }
    : {},
  '&:hover::before': { maxWidth: '100%' }
}));

export const ListIconStyle = {
  minWidth: 40,
  width: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const IconStyle = {
  width: 22,
  height: 22,
  color: '#fff',
  marginRight: 12,
  opcity: 0.3
};

export const CustomListItemText = styled(ListItemText)(() => ({
  margin: 0,
  '& > span': {
    fontSize: 14,
    fontWeight: 300,
    position: 'relative',
    zIndex: 100,
    fontFamily: 'Poppins, sans-serif'
  }
}));

export const CustomBox = styled(Box)(() => ({
  '& ul.MuiList-root > :nth-of-type(2)': {
    bottom: 38
  }
}));

export const TextDecorationNone = {
  textDecoration: 'none'
};

export const CustomIconButton = styled(IconButton)(() => ({
  position: 'fixed',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1300,
  backgroundColor: primary.main,
  border: `2px solid ${primary.main}`,
  transition: 'left 0.3s',
  color: '#fff',
  height: 40,
  width: 40,

  '&:hover': {
    backgroundColor: primary.hover,
    color: '#fff',
    zIndex: 1300
  }
}));
